import { MapPin } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
    return (
        <footer className="relative overflow-hidden border-t border-white/5 bg-[#0D0E15]/60" data-testid="footer">
            <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8">
                <button
                    onClick={() => scrollToId("#top")}
                    className="block w-full text-left"
                    data-testid="footer-brand"
                >
                    <span className="text-outline block font-display text-[11vw] font-extrabold leading-none tracking-tight lg:text-8xl">
                        LAS VEGAS
                    </span>
                    <span className="block font-display text-[11vw] font-extrabold leading-none tracking-tight text-white lg:text-8xl">
                        RESTROOM <span className="text-neon-magenta neon-magenta">LOCATOR</span>
                    </span>
                </button>

                <div className="mt-14 flex flex-col gap-8 border-t border-white/5 pt-8 md:flex-row md:items-center md:justify-between">
                    <div className="flex items-center gap-3">
                        <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-neon-cyan/40 bg-neon-cyan/10">
                            <MapPin className="h-4 w-4 text-neon-cyan" />
                        </span>
                        <span className="font-mono text-xs uppercase tracking-widest text-slate-500">
                            Fremont to Mandalay — Fully Mapped
                        </span>
                    </div>

                    <nav className="flex flex-wrap gap-6">
                        <button onClick={() => scrollToId("#features")} className="font-mono text-xs uppercase tracking-widest text-slate-500 transition-colors hover:text-neon-cyan" data-testid="footer-features-link">
                            The App
                        </button>
                        <button onClick={() => scrollToId("#faq")} className="font-mono text-xs uppercase tracking-widest text-slate-500 transition-colors hover:text-neon-cyan" data-testid="footer-faq-link">
                            FAQ
                        </button>
                        <button onClick={() => scrollToId("#support")} className="font-mono text-xs uppercase tracking-widest text-slate-500 transition-colors hover:text-neon-cyan" data-testid="footer-support-link">
                            Support
                        </button>
                        <a href="/privacy" className="font-mono text-xs uppercase tracking-widest text-slate-500 transition-colors hover:text-neon-cyan" data-testid="footer-privacy-link">
                            Privacy
                        </a>
                        <a href="/terms" className="font-mono text-xs uppercase tracking-widest text-slate-500 transition-colors hover:text-neon-cyan" data-testid="footer-terms-link">
                            Terms
                        </a>
                    </nav>

                    <span className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-neon-emerald">
                        <span className="h-2 w-2 rounded-full bg-neon-emerald animate-neon-pulse" />
                        Support Online
                    </span>
                </div>

                <div className="mt-8 space-y-2">
                    <p className="text-xs text-slate-600">
                        Apple and the Apple logo are trademarks of Apple Inc., registered in
                        the U.S. and other countries. App Store is a service mark of Apple Inc.
                    </p>
                    <p className="text-xs text-slate-600" data-testid="footer-copyright">
                        © 2026 Las Vegas Restroom Locator. All rights reserved. What happens
                        in Vegas stays mapped.
                    </p>
                </div>
            </div>
        </footer>
    );
}
